import { useQueries } from '@tanstack/react-query'
import { formsAPI } from '../../api/crm'
import { useEntityTypes, useTenantKey } from '../../hooks/useCrmQueries'
import { allFields } from '../records/fieldValues'

/** Fields of every published form of a record type (first form wins per key), like the backend. */
export const useEntityFields = (entityType) => {
  const tenantId = useTenantKey()
  const { forms } = useEntityTypes()
  const codes = forms.filter((f) => f.entityType === entityType).map((f) => f.code)
  const results = useQueries({
    queries: codes.map((code) => ({
      queryKey: [tenantId, 'forms', 'published', code],
      queryFn: () => formsAPI.published(code),
      enabled: !!tenantId,
    })),
  })
  const byKey = {}
  results.forEach((r) => allFields(r.data).forEach((f) => { if (!byKey[f.fieldKey]) byKey[f.fieldKey] = f }))
  return { fields: Object.values(byKey), byKey, isLoading: results.some((r) => r.isLoading) }
}
